import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GraphService } from './graph.service';

@Injectable({
  providedIn: 'root',
})
export class AventuraService {
  constructor(
    private http: HttpClient,
    private queryGQL: GraphService,
  ) {}

  getProperty(property: any) {
    return property;
  }

  getAllEquiposInventario(): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query{
        getAllEquiposInventario{
          id,
          codigo,
          factura{
            razonSocial,
            ruc,
            numFactura
          },
          nombreEquipo,
          marcaEquipo,
          modeloEquipo,
          tallaEquipo,
          valoracionEquipo,
          observacionEquipo,
          cantidad,
          costo,
          categoria,
          estado,
          fileAsignado
          }
      }`,
      variables: {},
    });
  }

  deleteEquipoInventario(id: String): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation deleteEquipoInventario($id: String!){
        deleteEquipoInventario(id: $id){
          id,
        }
      }`,
      variables: { id },
    });
  }

  getEquipoInventario(id: String): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getEquipoInventario($id:String!){
        getEquipoInventario(id:$id){
            id,
            codigo,
            factura{
            razonSocial,
            ruc,
            numFactura
            },
            nombreEquipo,
            marcaEquipo,
            modeloEquipo,
            valoracionEquipo,
            observacionEquipo,
            tallaEquipo,
            costo,
            categoria
        }
      }`,
      variables: { id },
    });
  }

  createEquipoInventario(equipo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation createEquipoInventario($equipo: inputEquipoInventario_Dto!){
        createEquipoInventario(equipo: $equipo){
          id,
          nombreEquipo,
          categoria,
          marcaEquipo,
          tallaEquipo,
          modeloEquipo,
          valoracionEquipo,
          observacionEquipo
        }
      }`,
      variables: { equipo },
    });
  }

  updateEquipoInventario(id: String, equipo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation updateEquipoInventario($id:String!, $equipo: inputEquipoInventario_Dto!){
        updateEquipoInventario(id:$id, equipo: $equipo){
          nombreEquipo,
          categoria,
          marcaEquipo,
          tallaEquipo,
          modeloEquipo,
          valoracionEquipo,
          observacionEquipo
        }
      }`,
      variables: { id, equipo },
    });
  }

  updateFileEquipos(id: String, equipos: any): Observable<any> {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateItineraryEquipos($id:String!, $equipos: [inputEquipo_Dto!]!){
        updateItineraryEquipos(id:$id, equipos: $equipos){
          id
        }
      }`,
      variables: { id, equipos },
    });
  }

  updateIngreso(id: String, almacenInsumo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation updateIngreso($id:String!, $almacenInsumo: inputAlmacen_Dto!){
        updateIngreso(id:$id, almacenInsumo: $almacenInsumo){
             id,
          factura{
            razonSocial,
            ruc,
            numFactura
          },
          locacion,
          fechaEntrada,
          detalleInsumos{
            id,
            nombreInsumo,
            unidadMedida,
            cantidad,
            costo,
            categoria
          }
        }
      }`,
      variables: { id, almacenInsumo },
    });
  }

  getAllEquipos(): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query{
        getAllEquipos{
          id,
          codigo,
          nombre,
          marca,
          modelo,
          talla,
          categoria,
          }
      }`,
      variables: {},
    });
  }

  deleteEquipo(id: String): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation deleteEquipo($id: String!){
        deleteEquipo(id: $id){
          id,
        }
      }`,
      variables: { id },
    });
  }

  getEquipo(id: String): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getEquipo($id:String!){
        getEquipo(id:$id){
          id,
          codigo,
          nombre,
          marca,
          modelo,
          talla,
          categoria,
        }
      }`,
      variables: { id },
    });
  }

  createEquipo(equipo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation createEquipo($equipo: inputEquipo_Dto!){
        createEquipo(equipo: $equipo){
          id,
        }
      }`,
      variables: { equipo },
    });
  }

  updateEquipo(id: String, equipo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation updateEquipo($id:String!, $equipo: inputEquipo_Dto!){
        updateEquipo(id:$id, equipo: $equipo){

          nombre
        }
      }`,
      variables: { id, equipo },
    });
  }

  updateProductById(id: String, product: any): Observable<any> {
    return this.queryGQL.mutateGraphQLProduct<any>({
      mutation: `mutation updateProductById($id:String!, $product: ProductInput!){
        updateProductById(id:$id, product: $product){

          nombre
        }
      }`,
      variables: { id, product },
    });
  }

  addProductAgrupadoWarehouse(id: String, agrupadoId: any): Observable<any> {
    return this.queryGQL.mutateGraphQLProduct<any>({
      mutation: `mutation addProductAgrupadoWarehouse($id:String!, $agrupadoId: String!){
        addProductAgrupadoWarehouse(id:$id, agrupadoId: $agrupadoId){

          nombre
        }
      }`,
      variables: { id, agrupadoId },
    });
  }

  deleteProductAgrupadoWarehouse(id: String, agrupadoId: any): Observable<any> {
    return this.queryGQL.mutateGraphQLProduct<any>({
      mutation: `mutation deleteProductAgrupadoWarehouse($id:String!, $agrupadoId: String!){
        deleteProductAgrupadoWarehouse(id:$id, agrupadoId: $agrupadoId){

          nombre
        }
      }`,
      variables: { id, agrupadoId },
    });
  }

  getAllCategorias(): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query{
        getAllCategorias{
          id,
          nombre,
          productos{
            id,
            nombre
          }
          }
      }`,
      variables: {},
    });
  }

  getAllProducts(): Observable<any> {
    return this.queryGQL.queryGraphQLProduct<any>({
      query: `query{
        getAllProducts{
          id,
          nombre,
          tipoProducto,
          categoriaProducto
          }
      }`,
      variables: {},
    });
  }

  getAllAgrupadoEquipoByCategoriaId(id: String): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getAllAgrupadoEquipoByCategoriaId($id:String!){
        getAllAgrupadoEquipoByCategoriaId(id:$id){
          id,
          categoriaId,
          categoriaNombre,
          equipoId,
          nombreEquipo,
          tallaEquipo,
          marcaEquipo,
          modeloEquipo,
          pesoEquipo,
          nroPersonasPax
        }
      }`,
      variables: { id },
    });
  }

  deleteCategoria(id: String): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation deleteCategoria($id: String!){
        deleteCategoria(id: $id){
          id,
        }
      }`,
      variables: { id },
    });
  }

  updateAgrupadoEquipo(id: String, equipo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation updateAgrupadoEquipo($id:String!, $equipo: inputAgrupadoEquipos_Dto!){
        updateAgrupadoEquipo(id:$id, equipo: $equipo){
          id
        }
      }`,
      variables: { id, equipo },
    });
  }

  createAgrupadoEquipo(equipo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation createAgrupadoEquipo($equipo: inputAgrupadoEquipos_Dto!){
        createAgrupadoEquipo(equipo: $equipo){
          id,
        }
      }`,
      variables: { equipo },
    });
  }

  deleteAgrupadoEquipo(id: String): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation deleteAgrupadoEquipo($id: String!){
        deleteAgrupadoEquipo(id: $id){
          id,
        }
      }`,
      variables: { id },
    });
  }

  createCategoria(categoria: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation createCategoria($categoria: inputCategoriaAgrupado_Dto!){
        createCategoria(categoria: $categoria){
          id,
        }
      }`,
      variables: { categoria },
    });
  }

  updateCategoria(categoria: any, id: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation updateCategoria($id: String!,$categoria: inputCategoriaAgrupado_Dto!){
        updateCategoria(id: $id,categoria: $categoria){
          id,
        }
      }`,
      variables: { categoria, id },
    });
  }

  getAllEgresoEquipos(): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query{
        getAllEgresoEquipos{
          id,
          equipoInventarioId,
          equipoId,
          fileId,
          fileNumber,
          fileDate,
          productId,
          estado,
          equipoInfo{
            id
            categoria
            codigo
            nombreEquipo
            marcaEquipo
            modeloEquipo
            tallaEquipo
            }
          }
      }`,
      variables: {},
    });
  }

  updateEgresoEquipo(id: String, egreso: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation updateEgresoEquipo($id:String!, $egreso: inputEgresoEquipo_Dto!){
        updateEgresoEquipo(id:$id, egreso: $egreso){
          id
        }
      }`,
      variables: { id, egreso },
    });
  }
}
